const useQueryParams = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  const queryParams = window.location.search;
  // tslint:disable-next-line:no-empty
  const setQueryParams = () => {};
  return [queryParams, setQueryParams];
};

export default useQueryParams;
